module.exports = __webpack_public_path__ + "static/img/msz.48ff21b.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/msz.png
// module id = yz1R
// module chunks = 1